import { BaseStoreModule } from '@core/store/helpers/base-store-module';
import { MAP_WIDGETS_NUMBER_OF_ROWS_PER_PAGE, WIDGET_LOGICAL_NAMES } from '@config/Consts';
import state from './state';
import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default BaseStoreModule({
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  submodules: {
    pagination: {
      enabled: true,
      widgetName: 'skillList', // todo normalize widgets name to be unified across all systems!
      pageSize: MAP_WIDGETS_NUMBER_OF_ROWS_PER_PAGE[WIDGET_LOGICAL_NAMES.SKILLS],
    },
  },
});
